<section>
  <div>
    <div class="page_name">{{ 'Pages.NotFound.Title' | translate }}</div>
    <div>
      <b>{{ 'Pages.NotFound.Content' | translate }}</b>
    </div>
  </div>
</section>
